import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useReduxAction from 'hooks/useReduxAction'
import { SET_CURRENT_USER, SET_OFFICE } from 'store/actions'

const useCurrentUser = () => {
  const { currentUser } = useSelector((state) => state.customization)

  const {
    errors,
    loaded,
    loading,
    result: current,
  } = useReduxAction('users', 'loadCurrentUser', {}, [], {
    shouldPerformFn: (entityReducer) => {
      const { errors, loaded, loading } = entityReducer
      return !loaded && !loading && !errors?.length && !currentUser
    },
  })

  const dispatch = useDispatch()

  useEffect(() => {
    if (current && !currentUser) {
      dispatch({ type: SET_CURRENT_USER, currentUser: current })

      if (current.roles?.includes('Client_Admin') && current.client_admin?.offices?.length === 1) {
        dispatch({ type: SET_OFFICE, office: current.client_admin.offices[0] })
      }
    }
  }, [current, currentUser, dispatch])

  return {
    currentUser,
    errors,
    loaded,
    loading,
  }
}

export default useCurrentUser
